import React from 'react';
import PropTypes from 'prop-types';

import { useDialog } from 'utils/hooks';
import { getTermsAndConditionsURL } from 'utils/helpers';
import { RoleNames } from 'utils/constants';
import { texts } from 'utils/languages/fr';

import { CheckboxLabel, PDFDialog } from 'components';
import { Typography, FormGroup } from '@mui/material';
import { useMatchAtLeastOneRole } from 'utils/hooks/subscriptions';

const ConditionsForm = ({ conditions, onChange }) => {
    const isDistributor = useMatchAtLeastOneRole([RoleNames.PSI, RoleNames.ADMIN_CIF], true);
    const termsAndConditionsURL = getTermsAndConditionsURL();

    const {
        open: conditionsOpen,
        onOpen: handleOpenConditions,
        onClose: handleCloseConditions,
    } = useDialog();

    if (!conditions) {
        return null;
    }

    return (
        <React.Fragment>
            <PDFDialog
                open={conditionsOpen}
                onClose={handleCloseConditions}
                title={texts.CONDITIONS_GENERALES}
                url={termsAndConditionsURL}
            />
            <FormGroup sx={{ mb: '3%' }}>
                <CheckboxLabel
                    name="termsAgreement"
                    checked={conditions.termsAgreement}
                    onChange={onChange}
                    label={
                        <Typography>
                            {texts.J_ACCEPTE}
                            <Typography
                                component="span"
                                onClick={handleOpenConditions}
                                sx={{
                                    cursor: 'pointer',
                                    color: 'primary.main',
                                    '&:hover': { textDecoration: 'underline' },
                                }}
                            >
                                {texts.CONDITIONS_GENERALES}
                            </Typography>
                        </Typography>
                    }
                />
                <CheckboxLabel
                    checked={conditions.acceptedEmails}
                    onChange={onChange}
                    name="acceptedEmails"
                    label={texts.J_ACCEPTE_D_ETRE_CONTACTEE(isDistributor)}
                />
            </FormGroup>
        </React.Fragment>
    );
};

ConditionsForm.propTypes = {
    conditions: PropTypes.object,
    onChange: PropTypes.func,
};

export default ConditionsForm;
